import { createFileRoute } from '@tanstack/react-router'

import { PaginaIssueFrango } from '@/features/frango/pagina-issue'

export const Route = createFileRoute('/$perfil/frango/$projeto/$iid')({
  component: Tela,
})

function Tela() {
  const { perfil, projeto, iid } = Route.useParams()
  return <PaginaIssueFrango perfil={perfil} projeto={projeto} iid={iid} />
}
